import { render, staticRenderFns } from "./delete-diode-form.vue?vue&type=template&id=395db08e&scoped=true&"
import script from "./delete-diode-form.vue?vue&type=script&lang=js&"
export * from "./delete-diode-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395db08e",
  null
  
)

export default component.exports